export enum KnmSubjectTypesEnum {
  FIZ = 'Физические лица',
  UR = 'Юридические лица',
  IP = 'Индивидуальные предприниматели',
  IFIZ = 'Иностранные физические лица',
  IUR = 'Иностранные юридические лица',
  FIUR = 'Филиал иностранного юридического лица',
}
